export default __webpack_public_path__ + "static/media/Text-3.546ffac8.png";